export default "__VITE_ASSET__BH_4R7Cn__"